export function useSettingsRoute() {
  const settingsFlowRouteName = "settings";

  const { currentRoute, rootRoute, parseRoute, resolveRouteContext } =
    useRouteGuard();

  const currentRouteContext = computed(() => {
    return resolveSettingsRouteContext(currentRoute.value);
  });

  const resolveSettingsRouteContext = (route: RouteContextInput) => {
    return resolveRouteContext(route, {
      matchPrefixes: {
        settingsFlow: settingsFlowRouteName,
        invitesFlow: "invites",
        paymentFlow: `${settingsFlowRouteName}-payment-method`,
      },
      queryDefaults: {
        [SESSION_ID_QUERY_PARAM]: undefined as string | undefined,
      },
    });
  };

  const createSettingsPath = (
    options?:
      | { error: true }
      | {
          section: "subscription" | "payment-method";
        },
  ) => {
    if (options && "error" in options) {
      // TODO: handle error case properly
      return parseRoute("/settings/error");
    }

    if (!options || !("section" in options)) {
      return parseRoute({
        name: settingsFlowRouteName,
      });
    }

    return parseRoute({
      name: `${settingsFlowRouteName}-${options.section}`,
    });
  };

  return {
    currentRouteContext,
    resolveSettingsRouteContext,
    createSettingsPath,
    rootRoute,
    routeNames: {
      settingsFlowRouteName,
    },
  };
}
